import Vue from "vue";
import { Select, Option, Input, Button, Popover, Dialog } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);
Vue.use(Popover);
Vue.use(Dialog);
